module.exports = __webpack_public_path__ + "img/bg_03.d2080022.png";